import { ExitToApp, Menu as MenuIcon } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../../images/image.png";
import { tokens } from "../../theme";
import { clearAdminSession } from "../../utils/adminSession";

const Topbar = ({ onMenuClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Log Out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        clearAdminSession();
        navigate("/");
      }
    });
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={1}
      sx={{
        background: "linear-gradient(to right, #1976d2, #42a5f5) !important",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        height: "74px",
        margin: 0,
        padding: "0 16px",
      }}
    >
      {/* Left Section - Logo and Title */}
      <Box display="flex" alignItems="center" gap={1}>
        {isMobile && (
          <IconButton
            onClick={onMenuClick}
            sx={{
              color: theme.palette.common.white,
              mr: 0.5,
            }}
            aria-label="Open navigation menu"
          >
            <MenuIcon />
          </IconButton>
        )}
        <Avatar
          alt="company-logo"
          src={logo}
          sx={{
            width: 40,
            height: 40,
            border: `2px solid ${alpha(theme.palette.common.white, 0.8)}`,
            backgroundColor: "white",
            padding: "3px",
          }}
        />
        <Typography
          variant="h4"
          sx={{
            color: theme.palette.common.white,
            fontWeight: 600,
            letterSpacing: "0.5px",
            fontSize: { xs: "1.3rem", sm: "1.6rem" },
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
          }}
        >
          Oi-Jo Admin
        </Typography>
      </Box>

      {/* Right Section - Logout Button */}
      <Box display="flex" alignItems="center">
        {/* Logout Button - visible on larger screens */}
        <Button
          color="inherit"
          startIcon={<ExitToApp />}
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "16px", sm: "20px" },
            textTransform: "none",
            color: theme.palette.common.white,
            display: { xs: "none", md: "flex" },
            "&:hover": {
              backgroundColor: alpha(theme.palette.common.white, 0.15),
            },
          }}
          onClick={handleLogout}
        >
          Log Out
        </Button>

        {/* Visible on mobile screens */}
        <IconButton
          onClick={handleLogout}
          sx={{
            display: { xs: "flex", md: "none" },
            color: theme.palette.common.white,
            backgroundColor: alpha(theme.palette.common.white, 0.1),
            "&:hover": {
              backgroundColor: alpha(theme.palette.common.white, 0.2),
            },
            padding: 0.5,
          }}
          size="small"
        >
          <ExitToApp fontSize="small" />
        </IconButton>

        {/* User Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 2,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
              mt: 1.5,
              minWidth: 200,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <ExitToApp fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{ color: theme.palette.error.main }} />
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;